export default "__VITE_ASSET__BjnoL917__"